var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconChevronLeft = function SvgIconChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14667 8.48055C6.05287 8.38687 6.00012 8.25978 6 8.12722V7.87389C6.00154 7.74161 6.05408 7.61503 6.14667 7.52055L9.57333 4.10055C9.63592 4.03745 9.72112 4.00195 9.81 4.00195C9.89888 4.00195 9.98408 4.03745 10.0467 4.10055L10.52 4.57389C10.5827 4.63533 10.618 4.71943 10.618 4.80722C10.618 4.89501 10.5827 4.97911 10.52 5.04055L7.55333 8.00055L10.52 10.9606C10.5831 11.0231 10.6186 11.1083 10.6186 11.1972C10.6186 11.2861 10.5831 11.3713 10.52 11.4339L10.0467 11.9006C9.98408 11.9637 9.89888 11.9992 9.81 11.9992C9.72112 11.9992 9.63592 11.9637 9.57333 11.9006L6.14667 8.48055Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconChevronLeft.6c1e17f9.svg";
export { ForwardRef as ReactComponent };